type VoidFn = () => void;

let lastActivity = Date.now();
const activityListeners = new Set<VoidFn>();
const expiredListeners = new Set<VoidFn>();

export const sessionActivity = {
  /** Called by apiClient on every successful authenticated request. */
  notifyActivity(): void {
    lastActivity = Date.now();
    activityListeners.forEach((cb) => cb());
  },

  getLastActivity(): number {
    return lastActivity;
  },

  /** Called by apiClient when a 401 occurs and token refresh also fails. */
  notifyExpired(): void {
    expiredListeners.forEach((cb) => cb());
  },

  onActivity(cb: VoidFn): VoidFn {
    activityListeners.add(cb);
    return () => activityListeners.delete(cb);
  },

  onExpired(cb: VoidFn): VoidFn {
    expiredListeners.add(cb);
    return () => expiredListeners.delete(cb);
  },

  /** Reset the activity timestamp – called when a new authenticated session begins. */
  resetOnLogin(): void {
    lastActivity = Date.now();
  },
};
